import Vue from 'vue';
import dayjs from 'dayjs';

Vue.filter('dateFormat', function (value) {
  return !value ? "" : dayjs(value).format("YYYY-MM-DD HH:mm:ss");
});

Vue.filter('dateCoverToTime', function (value) {
  return !value ? "" : dayjs(value).format("HH:mm:ss");
});

Vue.filter('dateFormatYMD', function (value) {
  return !value ? "" : dayjs(value).format("YYYY-MM-DD");
});
Vue.filter('dateFormatYMD2', function (value) {
  return !value ? "" : dayjs(value).format("YYYY.MM.DD");
});